module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-12-762e16aa7edbd294603381bf7bdd8315.jpg";